import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import App from './App.vue'
import store from './store'


Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(Vuex)

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
